import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
import emitter from "@/events/eventBus";
import {trimInputValue} from "@/main-page/utils/ctlUseComUtils";

export function useInputChangeHook({placeholderLabel='',emits, props, events, formObj, model}: any) {
  const {clickEvent} = useComEvent({events});
  /**
   * 值发生变化
   * @param e
   * @param params
   */
  const changeInput = function (e, params = {},curSelObj={}) {
    nextTick(() => {
      emits&&emits('change',{formObj:unref(formObj),curObj:unref(props),itemValue:unref(formObj)[unref(model).key]})
      clickEvent('change', {
        curSelObj:unref(curSelObj),
        curObj: unref(props),
        value: unref(formObj)&&unref(formObj)[unref(model).key],
        formObj: unref(formObj), 
        ...params,
        curOption: e,
      });

    })
  }

  const blurInput = function (e, params = {},curSelObj={}) {
    const fieldKey = unref(model)?.key;
    if (fieldKey && unref(formObj)) {
      const currentVal = unref(formObj)[fieldKey];
      const trimmedVal = trimInputValue(currentVal);
      if (trimmedVal !== currentVal) {
        unref(formObj)[fieldKey] = trimmedVal;
      }
    }
    nextTick(() => {
      clickEvent('blur', {
        curSelObj:unref(curSelObj),
        curObj: unref(props),
        value: unref(formObj)&&unref(formObj)[unref(model).key],
        formObj: unref(formObj), ...params
      });
      emits&&emits('blur',{formObj:unref(formObj),curObj:unref(props),itemValue:unref(formObj)[unref(model).key]})
    })
  }


  /**
   * 点击输入框
   */
  const clickInput=function () {
    (window as any).FunctionEngine.inputPropsKey=unref(props).key;
    clickEvent('click', {
      curObj: unref(props),
      value: unref(formObj)&&unref(formObj)[unref(model).key],
      formObj: unref(formObj)
    });
    emits('clickInput', {names: [unref(model).key]});
  }

  /**
   * 选择并情况错误提示
   * @param params
   */
  const selAndClearError=function (){
    if(unref(model)&&unref(formObj)[unref(model).key]){
      emitter.emit('clearValidateForm', {names: [unref(model).key]});
    }
    nextTick(()=>{
      if(unref(model)){
        emitter.emit('ValidateForm', {names: [unref(model).key]});
      }
    })
  }


  /**
   * 数据加载完成后执行
   */
  const afterLoadData = function (tableDs) {
    clickEvent('afterLoadData', {list:tableDs});
    emits&&emits('afterLoadData', {list:tableDs})
  }

  /**
   * 组件加载完成后事件
   */
  onMounted(()=>{
    clickEvent('onMounted', {formObj:unref(formObj)});
  })

  /**
   * 点击弹框
   */
  const openWin=function (){
    clickEvent('clickIcon', {formObj:unref(formObj)});
  }
  const getDefPlaceholder = computed(() => {
    return unref(placeholderLabel) && unref(placeholderLabel).length > 0 ? "请输入" + unref(placeholderLabel) : "请输入" + (unref(props).label || unref(props).propName);
  })

  const getDisPlaceholder= computed(() => {
    return unref(placeholderLabel) && unref(placeholderLabel).length > 0 ? "" + unref(placeholderLabel) : "" + (unref(props).label || unref(props).propName);
  })

  const appendBtnClick=function (){
    clickEvent('appendBtnClick', {formObj:unref(formObj)});
  }

  return {
    appendBtnClick,
    openWin,
    getDisPlaceholder,
    getDefPlaceholder,
    clickInput,
    selAndClearError,
    afterLoadData,
    changeInput,
    blurInput
  }
}
